import React from 'react'
import s from './styles/TimeInput.module.scss'
import { useTimeInput } from './hooks/useTimeInput'

// Universal time input: accepts up to 4 numeric chars (hhmm),
// formats to 12h with AM/PM switch, and emits 24h string "HH:MM" via onChange.
const TimeInput = ({ value, onChange, className = '', inputClassName = '' }) => {
	const { display, ap, setRaw, onBlur, setAP } = useTimeInput({
		value,
		onChange,
	})

	return (
		<div className={`${s.root} ${className}`.trim()}>
			<input
				type="text"
				className={`${s.input} ${inputClassName}`.trim()}
				value={display}
				onChange={e => setRaw(e.target.value)}
				onBlur={onBlur}
				inputMode="numeric"
				maxLength={5}
				placeholder="hh:mm"
				aria-label="Time"
			/>
			<div className={s.periodToggle} aria-label="Select AM or PM">
				{['AM', 'PM'].map(period => (
					<button
						key={period}
						type="button"
						className={`${s.periodBtn} ${ap === period ? s.periodBtnActive : ''}`}
						onClick={() => setAP(period)}
						aria-pressed={ap === period}
					>
						{period}
					</button>
				))}
			</div>
		</div>
	)
}

export default TimeInput
